import { Link } from "react-router-dom";
import "./brand-header.css";

/** Brand-mark-only header used on entry / edge screens. */
export function BrandHeader() {
  return (
    <header className="wp-brand">
      <Link to="/" className="wp-brand__link">
        <span aria-hidden="true" className="wp-brand__mark">
          W
        </span>
        <span className="wp-brand__name">WhoPaid</span>
      </Link>
    </header>
  );
}
